<template>
  <div class="questionnaire-wrapper">
    <div v-if="config.status === 3" class="questionnaire-container">
      <div class="questionnaire-info">
        <div v-if="config.mainImgUrl" class="main-img">
          <img :src="config.mainImgUrl" class="img-box" />
        </div>
        <div class="title">{{ config.title }}</div>
        <div class="description">{{ config.description }}</div>
      </div>
      <div v-if="questionList.length > 0" class="question-list">
        <div v-for="(item, index) in questionList" :key="index">
          <div
            v-show="!item.isHide"
            class="question-item"
            :class="item.type === 4 ? 'question-title-desc' : ''"
          >
            <div
              class="item-title"
              v-if="item.type === 0 || item.type === 2 || item.type === 3"
            >
              <span v-if="item.required === true" class="question-require"
                >*</span
              >
              {{ item.questionNumber }}、{{ item.questionTitle }}
            </div>
            <div class="item-title item-title-filling" v-if="item.type === 1">
              <span v-if="item.required === true" class="question-require"
                >*</span
              >
              <span class="item-title-number">{{ item.questionNumber }}、</span>
              <div class="item-stem" v-html="item.questionTitle"></div>
            </div>
            <div class="item-title" v-if="item.type === 4">
              {{ item.questionTitle }}
            </div>
            <div class="item-radio" v-if="item.type === 2">
              <van-radio-group
                v-model="item.val"
                checked-color="#EA2D2D"
                :disabled="disabled"
              >
                <div
                  v-for="(radioItem, radioIndex) in item.questionOptionList"
                  :key="radioIndex"
                  class="option-item-container"
                >
                  <div class="option-item">
                    <van-radio
                      :name="radioItem.id"
                      class="item-height"
                      @click="changeRadioItem(index, radioIndex)"
                    >
                      {{ radioItem.content }}
                    </van-radio>
                  </div>
                  <div
                    v-if="shouldShowTextInput(radioItem)"
                    class="sub-input-box"
                  >
                    <van-field
                      size="small"
                      v-model="radioItem.inputValue"
                      class="question-input-line"
                      label=""
                      placeholder="请输入内容"
                      :disabled="disabled"
                    />
                  </div>
                  <div
                    v-if="shouldShowPicUpload(radioItem)"
                    class="uploader-box"
                  >
                    <div
                      v-if="radioItem.imgUrl || (radioItem.fileList && radioItem.fileList.length > 0)"
                      class="img-preview-box"
                    >
                      <img
                        :src="radioItem.imgUrl || (radioItem.fileList && radioItem.fileList[0] && radioItem.fileList[0].url)"
                        class="preview-img"
                      />
                      <div
                        v-if="!disabled"
                        class="delete-icon-box"
                        @click.stop="handleDeleteImg(radioItem)"
                      >
                        <van-icon name="cross" color="#ffffff" size="12" />
                      </div>
                    </div>
                    <div
                      v-else
                      class="upload-btn-tile"
                      @click="handleChooseImg(radioItem)"
                    >
                      <van-icon name="photograph" size="24" color="#dcdee0" />
                    </div>
                  </div>
                </div>
              </van-radio-group>
            </div>
            <div class="item-checkBox" v-if="item.type === 3">
              <van-checkbox-group
                v-model="item.val"
                checked-color="#EA2D2D"
                :disabled="disabled"
                @change="changeCheckboxItem(index)"
              >
                <div
                  v-for="(radioItem, radioIndex) in item.questionOptionList"
                  :key="radioIndex"
                  class="option-item-container"
                >
                  <div class="option-item">
                    <van-checkbox
                      :name="radioItem.id"
                      shape="square"
                      class="item-height"
                      @click="changeCheckboxItem(index, radioIndex)"
                    >
                      {{ radioItem.content }}
                    </van-checkbox>
                  </div>
                  <div
                    v-if="shouldShowTextInput(radioItem)"
                    class="sub-input-box"
                  >
                    <van-field
                      v-model="radioItem.inputValue"
                      class="question-input-line"
                      label=""
                      placeholder="请输入内容"
                      :disabled="disabled"
                    />
                  </div>
                  <div
                    v-if="shouldShowPicUpload(radioItem)"
                    class="uploader-box"
                  >
                    <div
                      v-if="radioItem.imgUrl || (radioItem.fileList && radioItem.fileList.length > 0)"
                      class="img-preview-box"
                    >
                      <img
                        :src="radioItem.imgUrl || (radioItem.fileList && radioItem.fileList[0] && radioItem.fileList[0].url)"
                        class="preview-img"
                      />
                      <div
                        v-if="!disabled"
                        class="delete-icon-box"
                        @click.stop="handleDeleteImg(radioItem)"
                      >
                        <van-icon name="cross" color="#ffffff" size="12" />
                      </div>
                    </div>
                    <div
                      v-else
                      class="upload-btn-tile"
                      @click="handleChooseImg(radioItem)"
                    >
                      <van-icon name="photograph" size="24" color="#dcdee0" />
                    </div>
                  </div>
                </div>
              </van-checkbox-group>
            </div>
            <div class="item-field" v-if="item.type === 0">
              <van-field
                v-model="item.val"
                label=""
                placeholder="请输入内容"
                class="question-input"
                :disabled="disabled"
              />
              <div
                v-if="shouldShowFieldPicUpload(item)"
                class="uploader-box"
              >
                <div
                  v-if="item.imgUrl || (item.fileList && item.fileList.length > 0)"
                  class="img-preview-box"
                >
                  <img
                    :src="item.imgUrl || (item.fileList && item.fileList[0] && item.fileList[0].url)"
                    class="preview-img"
                  />
                  <div
                    v-if="!disabled"
                    class="delete-icon-box"
                    @click.stop="handleDeleteImg(item)"
                  >
                    <van-icon name="cross" color="#ffffff" size="12" />
                  </div>
                </div>
                <div
                  v-else
                  class="upload-btn-tile"
                  @click="handleChooseImg(item)"
                >
                  <van-icon name="photograph" size="24" color="#dcdee0" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div
        class="submit-btn-container"
        v-if="!disabled"
        @click="commitQuestionnaire"
      >
        <div class="submit-btn">提交</div>
      </div>
      <div
        class="submit-btn-container"
        v-if="disabled"
        :class="{ disabled: disabled }"
      >
        <div class="submit-btn">提交</div>
      </div>
    </div>
    <div v-if="config.status === 2" class="questionnaire-tips">
      <div class="tips-box">
        <div class="tips-icon">
          <!--<van-icon name="warning" size="60" color="#ee0924" />-->
          <img
            :src="require('@/assets/images/noResult2.png')"
            alt=""
            class="noResult"
          />
        </div>
        <div class="tips-content">此调查问卷已停止 不能填写</div>
      </div>
    </div>
    <div v-if="config.status === 5" class="questionnaire-tips">
      <div class="tips-box">
        <div class="tips-icon">
          <!--<van-icon name="warning" size="60" color="#ee0924" />-->
          <img
            :src="require('@/assets/images/noResult1.png')"
            alt=""
            class="noResult"
          />
        </div>
        <div class="tips-content">您已参与过</div>
      </div>
    </div>
    <div v-if="config.status === 1" class="questionnaire-tips">
      <div class="tips-box">
        <div class="tips-icon">
          <!--<van-icon name="warning" size="60" color="#ee0924" />-->
          <img
            :src="require('@/assets/images/noResult3.png')"
            alt=""
            class="noResult"
          />
        </div>
        <div class="tips-content">该问卷还未发布 请耐心等待哦</div>
      </div>
    </div>
  </div>
</template>

<script>
import { Toast } from 'vant'
import {
  commitQuestionnaire,
  getWxConfig,
  getNewQuestionnaire,
  wxGetAccessToken
} from '@/api'
import { initWx } from '@/utils/jssdk'

export default {
  name: 'index',
  data() {
    return {
      config: {
        status: 0,
        mainImgUrl: null,
        title: null,
        description: null,
        shareImgUrl: null
      },
      questionList: [], // 题目列表
      list: {
        radio: '1',
        checkBox: ['a'],
        field: null
      },
      disabled: false,
      questionNumber: 0,
      openId: null,
      currentOption: null
    }
  },
  created() {
    window.getImg = (res) => {
      if (!res) return
      if (this.currentOption) {
        this.$set(this.currentOption, 'imgUrl', res)
        this.$set(this.currentOption, 'fileList', [{ url: res }])
      }
    }
    // window.title = this.config.title
    const { platform } = this.$route.query
    const phone = this.getNormalizedPhone()
    // 1.没有手机号和平台类型就是分享打开,需要微信授权登录
    if (!platform && !phone && this.isWeixin()) {
      if (this.$route.query.redirect && this.$route.query.redirect === '1') {
        wxGetAccessToken({ code: this.$route.query.code }).then((res) => {
          this.openId = res.data.openid
          if (this.openId) {
            this.getNewQuestionnaire()
          }
          if (this.openId === null) {
            this.getOpenId()
          }
        })
      } else {
        this.getOpenId()
      }
    } else {
      // 2.如果存在手机号平台类型就是app内打开或者h5打开
      this.getNewQuestionnaire()
    }
  },
  methods: {
    getNormalizedPhone() {
      const { phone } = this.$route.query
      if (!phone) return null
      let phoneVal = phone
      if (Array.isArray(phone)) {
        // 传了多个 phone 参数时，优先使用加密的手机号（非普通11位明文格式）
        const encryptedPhone = phone.find((p) => {
          if (!p) return false
          const trimmed = String(p).trim()
          return trimmed && !/^1[3-9]\d{9}$/.test(trimmed)
        })
        phoneVal = encryptedPhone || phone.find((p) => p && String(p).trim()) || ''
      }
      const str = String(phoneVal).trim()
      if (!str) return null
      // 还原 URL 解码时误转为空格的 '+' 字符
      return str.replace(/ /g, '+')
    },
    isWeixin() {
      const ua = navigator.userAgent.toLowerCase()
      // alert(/micromessenger/i.test(ua))
      if (/micromessenger/i.test(ua)) {
        return true
      }
      return false
    },
    // 获取问卷信息
    getNewQuestionnaire() {
      const query = (this.$route && this.$route.query) || {}
      const {
        id, platform, app, preview, orderNo
      } = query
      const phone = this.getNormalizedPhone()
      const params = {
        questionnaireId: id || '',
        platform: platform || '',
        app: app || '',
        phone: phone || null,
        orderNo
      }
      if (this.openId) {
        params.openId = this.openId
      }
      getNewQuestionnaire(params)
        .then((config) => {
          if (this.$route.query.preview) {
            this.disabled = true
          }
          this.config.title = config.data.title
          window.title = config.data.title
          if (preview) {
            this.config.status = 3
          } else if (config.data.remark) {
            this.config.status = 5
          } else {
            this.config.status = config.data.status
            console.log(this.config.status)
          }
          this.config.mainImgUrl = config.data.mainImgUrl
          this.config.description = config.data.instruction
          this.config.shareImgUrl = config.data.shareImgUrl
          const { questionList } = config.data
          const reg = /___/gi
          questionList.forEach((item) => {
            if (item.type !== 4) {
              this.questionNumber += 1
              // item.questionTitle = `${this.questionNumber}、${item.questionTitle}`
              // eslint-disable-next-line no-param-reassign
              item.questionNumber = this.questionNumber
            }
            if (item.type === 1) {
              const result = item.questionTitle.match(reg)
              // console.log(result)
              // const inputArr = []
              if (result.length) {
                // result.forEach((subItem, subIndex) => {
                //   console.log(subIndex)
                //   // eslint-disable-next-line no-param-reassign
                //   item.questionTitleFill = item.questionTitle.replace(reg, '<input type="text"  class="filling-input" maxlength="20" />')
                // })
                // eslint-disable-next-line no-unused-vars,no-param-reassign
                item.questionTitle = item.questionTitle.replace(
                  reg,
                  '<input type="text"  class="filling-input" maxlength="20" />'
                )
              }
            }
          })
          this.questionList = questionList
          this.$nextTick(() => {
            this.updateQuestionLinkVisibility()
          })
          getWxConfig({ url: window.location.href })
            .then((res) => initWx(res.data))
            .then(() => {
              // eslint-disable-next-line no-undef
              wx.ready(() => {
                const content = {
                  title: config.data.shareTitle,
                  desc: config.data.shareContent,
                  link: window.location.href,
                  imgUrl: config.data.shareImgUrl,
                  success: () => {}
                }
                // eslint-disable-next-line no-undef
                wx.updateTimelineShareData(content)
                // eslint-disable-next-line no-undef
                wx.updateAppMessageShareData(content)
              })
              // eslint-disable-next-line no-undef
              wx.error((err) => {
                console.log(err)
              })
            })
            .catch((err) => {
              // this.disabled = true
              Toast(err.message)
            })
        })
        .catch((err) => {
          this.disabled = true
          Toast(err.message)
          // 问卷已过期时返回上一页 根据后端返回文案判断
          if (err && err.message && err.message === '问卷已过期。') {
            setTimeout(() => {
              this.goBackToNative()
            }, 1000)
          }
        })
    },
    // 关闭当前 WebView 返回 App 原生页面，桥接不可用时回退浏览器历史
    goBackToNative() {
      if (window.HarmonyOS && typeof window.HarmonyOS.closePage === 'function') {
        window.HarmonyOS.closePage()
      } else if (window.ohos && typeof window.ohos.closePage === 'function') {
        window.ohos.closePage()
      } else if (window.Android && typeof window.Android.closePage === 'function') {
        window.Android.closePage()
      } else if (
        window.webkit
        && window.webkit.messageHandlers
        && window.webkit.messageHandlers.closePage
      ) {
        window.webkit.messageHandlers.closePage.postMessage(null)
      } else if (window.uni && typeof window.uni.navigateBack === 'function') {
        window.uni.navigateBack()
      } else if (window.history.length > 1) {
        this.$router.back()
      }
    },
    getOpenId() {
      const appId = 'wxc81ff0696daa2a0a'
      const {
        id, platform, app, phone, preview
      } = this.$route.query
      const params = {
        id,
        platform,
        app,
        phone,
        preview
      }
      const paramsStr = JSON.stringify(params)
      const { port, hostname } = window.location
      const redirectUri = encodeURIComponent(
        `http://cloud.esvtek.com/auth-redirect/?params=${paramsStr}&port=${port}&hostname=${hostname}&path=/jac-direct-mall-activity-h5/questionnaire`
      )
      const responseType = 'code'
      const scope = 'snsapi_base'
      window.location.replace(
        `https://open.weixin.qq.com/connect/oauth2/authorize?appid=${appId}&redirect_uri=${redirectUri}&response_type=${responseType}&scope=${scope}&state=STATE#wechat_redire`
      )
    },
    handleChooseImg(radioItem) {
      if (this.disabled) return
      this.currentOption = radioItem
      const ua = navigator.userAgent.toLowerCase()
      const isIOS = /iphone|ipad|ipod|macintosh/i.test(ua)
      const isHarmony = /harmonyos|openharmony/i.test(ua) || typeof window.HarmonyOS !== 'undefined' || typeof window.ohos !== 'undefined'
      let hasNativeBridge = false

      try {
        if (isHarmony) {
          if (window.HarmonyOS && typeof window.HarmonyOS.getImg === 'function') {
            window.HarmonyOS.getImg()
            hasNativeBridge = true
          } else if (window.ohos && typeof window.ohos.getImg === 'function') {
            window.ohos.getImg()
            hasNativeBridge = true
          } else if (window.Android && typeof window.Android.getImg === 'function') {
            window.Android.getImg()
            hasNativeBridge = true
          }
        } else if (isIOS && window.webkit && window.webkit.messageHandlers && window.webkit.messageHandlers.getImg) {
          window.webkit.messageHandlers.getImg.postMessage(null)
          hasNativeBridge = true
        } else if (window.Android && typeof window.Android.getImg === 'function') {
          window.Android.getImg()
          hasNativeBridge = true
        }
      } catch (err) {
        console.warn('调用原生传图失败，降级使用H5传图:', err)
      }
    },
    triggerH5FileUpload(radioItem) {
      const input = document.createElement('input')
      input.type = 'file'
      input.accept = 'image/*'
      input.onchange = (e) => {
        const file = e.target.files && e.target.files[0]
        if (!file) return
        const reader = new FileReader()
        reader.onload = (event) => {
          const res = event.target.result
          this.$set(radioItem, 'imgUrl', res)
          this.$set(radioItem, 'fileList', [{ url: res, content: res, file }])
        }
        reader.readAsDataURL(file)
      }
      input.click()
    },
    handleDeleteImg(radioItem) {
      if (this.disabled) return
      this.$set(radioItem, 'imgUrl', '')
      this.$set(radioItem, 'fileList', [])
    },
    isAllowInput(radioItem) {
      if (!radioItem) return false
      return Number(radioItem.isInput) === 1 || Number(radioItem.isInput) === 2 || radioItem.isInput === true
    },
    shouldShowTextInput(radioItem) {
      if (!radioItem || !radioItem.isShowInput) return false
      return Number(radioItem.isInput) === 1 || radioItem.isInput === true
    },
    shouldShowPicUpload(radioItem) {
      if (!radioItem || !radioItem.isShowInput) return false
      const isInputVal = Number(radioItem.isInput)
      const isPicVal = Number(radioItem.isPic)
      return isInputVal === 2 || ((isInputVal === 1 || radioItem.isInput === true) && (isPicVal === 1 || radioItem.isPic === true))
    },
    shouldShowFieldPicUpload(item) {
      if (!item) return false
      const opt = (item.questionOptionList && item.questionOptionList[0]) || {}
      const isPic = item.isPic !== undefined ? item.isPic : opt.isPic
      const isInput = item.isInput !== undefined ? item.isInput : opt.isInput
      const isPicVal = Number(isPic)
      const isInputVal = Number(isInput)
      return isPicVal === 1 || isPic === true || isPicVal === 2 || isInputVal === 2
    },
    changeCheckboxItem(index) {
      this.$nextTick(() => {
        const questionItem = this.questionList[index]
        if (!questionItem) return
        const optionVal = questionItem.val || []
        const optionItems = questionItem.questionOptionList || []
        optionItems.forEach((subItem) => {
          if (optionVal.includes(subItem.id) && this.isAllowInput(subItem)) {
            this.$set(subItem, 'isShowInput', true)
          } else {
            this.$set(subItem, 'isShowInput', false)
          }
        })
        this.updateQuestionLinkVisibility()
      })
    },
    changeRadioItem(index) {
      const questionItem = this.questionList[index]
      if (!questionItem) return
      const optionVal = questionItem.val
      const optionItems = questionItem.questionOptionList || []
      optionItems.forEach((subItem) => {
        this.$set(subItem, 'isShowInput', false)
        if (subItem.id === optionVal && this.isAllowInput(subItem)) {
          this.$set(subItem, 'isShowInput', true)
        }
      })
      this.updateQuestionLinkVisibility()
    },
    // 核心规则：多选/单选顺序跳转逻辑
    updateQuestionLinkVisibility() {
      if (!this.questionList || this.questionList.length === 0) return

      // 1. 重置所有题目的隐藏状态为 false
      this.questionList.forEach((q) => {
        this.$set(q, 'isHide', false)
      })

      // 2. 从前往后遍历题目，逐层应用跳转与隐藏规则
      this.questionList.forEach((q, currIndex) => {
        if (q.isHide) return

        // --- A. 单选题 (type === 2) 跳转逻辑 ---
        if (q.type === 2 && q.val !== undefined && q.val !== null && q.val !== '') {
          const selectedOpt = (q.questionOptionList || []).find((opt) => opt.id === q.val)
          if (selectedOpt && selectedOpt.linkQuestionId) {
            const targetIndex = this.questionList.findIndex((item) => item.id === selectedOpt.linkQuestionId)
            if (targetIndex > currIndex) {
              for (let i = currIndex + 1; i < targetIndex; i += 1) {
                this.$set(this.questionList[i], 'isHide', true)
              }
            }
          }
        }

        // --- B. 多选题 (type === 3) 顺序跳转逻辑 ---
        if (q.type === 3 && Array.isArray(q.val)) {
          const optionItems = q.questionOptionList || []
          const allTargetIndices = []
          optionItems.forEach((opt) => {
            if (opt.linkQuestionId) {
              const tIdx = this.questionList.findIndex((item) => item.id === opt.linkQuestionId)
              if (tIdx > currIndex) {
                allTargetIndices.push(tIdx)
              }
            }
          })

          if (allTargetIndices.length === 0) return

          const selectedTargetIndices = []
          optionItems.forEach((opt) => {
            if (q.val.includes(opt.id) && opt.linkQuestionId) {
              const tIdx = this.questionList.findIndex((item) => item.id === opt.linkQuestionId)
              if (tIdx > currIndex) {
                selectedTargetIndices.push(tIdx)
              }
            }
          })

          // 当未勾选任何带跳转逻辑的选项（或取消全选）时，不进行二次掩码隐藏，保持默认全部恢复显示
          if (selectedTargetIndices.length === 0) {
            return
          }

          const minSelected = Math.min(...selectedTargetIndices)
          const maxSelected = Math.max(...selectedTargetIndices)

          for (let i = currIndex + 1; i < this.questionList.length; i += 1) {
            const isAllTarget = allTargetIndices.includes(i)
            const isSelectedTarget = selectedTargetIndices.includes(i)

            if (isAllTarget) {
              if (isSelectedTarget) {
                this.$set(this.questionList[i], 'isHide', false)
              } else {
                this.$set(this.questionList[i], 'isHide', true)
              }
            } else if (i < minSelected) {
              this.$set(this.questionList[i], 'isHide', true)
            } else if (i > minSelected && i < maxSelected) {
              this.$set(this.questionList[i], 'isHide', true)
            }
          }
        }
      })
    },
    commitQuestionnaire() {
      this.disabled = true
      const {
        platform, app, address, id, orderNo, chassisNum, carModel
      } = this.$route.query
      const phone = this.getNormalizedPhone()
      const params = {
        platform: platform || '',
        app: app || '',
        phone: phone || null,
        address: address || '',
        questionnaireId: id || '',
        questionAnswerList: []
      }
      if (orderNo) {
        params.orderNo = orderNo
      }
      if (chassisNum) {
        params.chassisNum = chassisNum
      }
      if (carModel) {
        params.carModel = carModel
      }
      if (this.openId) {
        params.openId = this.openId
      }
      // try-catch判断是否有没填写的必答题
      try {
        this.questionList.forEach((paramsItem) => {
          // console.log(paramsItem.val)
          if (paramsItem.type === 4) {
            return
          }
          if (paramsItem.type === 1) {
            console.log(paramsItem.questionTitle)
          }
          // eslint-disable-next-line no-unreachable
          let content = ''
          let optionId = ''
          if (
            (paramsItem.val === undefined || paramsItem.val === '')
            && paramsItem.required === true
            && !paramsItem.isHide
          ) {
            throw new Error('请完整填写问卷')
          } else {
            if (paramsItem.type === 0 && !paramsItem.isHide) {
              // 单项填空
              content = paramsItem.val
            }
            if (paramsItem.type === 1 && !paramsItem.isHide) {
              // 横线填空
              // console.log(paramsItem.questionTitle)
              // content = paramsItem.val
            }
            if (paramsItem.type === 2 && !paramsItem.isHide) {
              optionId = paramsItem.val
              const selectedOpt = paramsItem.questionOptionList && paramsItem.questionOptionList.find((opt) => opt.id === paramsItem.val)
              content = (selectedOpt && selectedOpt.inputValue) || paramsItem.inputValue || ''
            }
            if (paramsItem.type === 3 && !paramsItem.isHide) {
              if (paramsItem.val && Array.isArray(paramsItem.val)) {
                // 多选
                optionId = paramsItem.val.join(',')
                const contentList = []
                paramsItem.val.forEach((selectedId) => {
                  const opt = paramsItem.questionOptionList && paramsItem.questionOptionList.find((o) => o.id === selectedId)
                  if (opt && opt.inputValue) {
                    contentList.push(opt.inputValue)
                  }
                })
                if (contentList.length > 0) {
                  content = contentList.join(',')
                } else {
                  content = paramsItem.inputValue || ''
                }
              }
            }

            let imgUrl = ''
            if (paramsItem.type === 0 && !paramsItem.isHide) {
              const opt = (paramsItem.questionOptionList && paramsItem.questionOptionList[0]) || {}
              imgUrl = paramsItem.imgUrl || (paramsItem.fileList && paramsItem.fileList[0] && (paramsItem.fileList[0].url || paramsItem.fileList[0].content)) || opt.imgUrl || (opt.fileList && opt.fileList[0] && (opt.fileList[0].url || opt.fileList[0].content)) || ''
            } else if ((paramsItem.type === 2 || paramsItem.type === 3) && !paramsItem.isHide && paramsItem.questionOptionList) {
              const imgList = []
              paramsItem.questionOptionList.forEach((opt) => {
                const isSelected = paramsItem.type === 2
                  ? opt.id === paramsItem.val
                  : (paramsItem.val && Array.isArray(paramsItem.val) && paramsItem.val.includes(opt.id))
                if (isSelected) {
                  const url = opt.imgUrl || (opt.fileList && opt.fileList[0] && (opt.fileList[0].url || opt.fileList[0].content))
                  if (url) {
                    imgList.push(url)
                  }
                }
              })
              if (imgList.length > 0) {
                imgUrl = imgList.join(',')
              }
            }

            const answerObj = {
              questionId: paramsItem.id,
              content,
              optionId,
              imgUrl,
              picUrl: imgUrl
            }
            params.questionAnswerList.push(answerObj)
          }
        })
        commitQuestionnaire(params)
          .then(() => {
            // console.log(res)
            Toast('提交成功')
          })
          .catch((err) => {
            Toast(err.message)
            this.disabled = false
          })
      } catch (e) {
        this.disabled = false
        if (e.message === '请完整填写问卷') {
          Toast('请完整填写问卷必填题')
        } else {
          console.log(e.message)
        }
      }
    }
  }
}
</script>
<style lang="scss">
.filling-input {
  width: rem(140);
  line-height: rem(40);
  padding: rem(10);
  border-left: 1px solid rgba(0, 0, 0, 0);
  border-top: 1px solid rgba(0, 0, 0, 0);
  border-right: 1px solid rgba(0, 0, 0, 0);
  border-bottom: 1px solid #eeeeee;
  margin: 0 rem(10);
  color: #333;
  font-size: rem(28);
  &:focus {
    border: 1px solid #1989fa;
  }
}
</style>
<style scoped lang="scss">
.questionnaire-tips {
  position: fixed;
  width: 100%;
  height: 100%;
  .tips-box {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -80%);
    width: 80%;
    font-size: rem(28);
    color: #666;
    text-align: center;
    .tips-title {
      line-height: rem(88);
      font-size: rem(34);
      color: #333;
      font-weight: 700;
    }
    .tips-content {
      line-height: rem(44);
    }
  }
}
.questionnaire-container {
  margin-bottom: rem(160);
  .questionnaire-info {
    background: #ffffff;
    margin-bottom: rem(16);
    border-bottom: 1px dashed #eeeeee;
    .main-img {
      height: rem(450);
      .img-box {
        width: 100%;
        height: 100%;
      }
    }
    .title {
      padding: rem(30) rem(24);
      color: #333333;
      font-size: rem(34);
      font-weight: bold;
      text-align: center;
    }
    .description {
      padding: rem(0) rem(24) rem(40);
      color: #999;
      font-size: rem(28);
    }
  }
  .question-list {
    width: 100%;
    .question-item {
      background-color: #fff;
      padding: rem(30);
      &.question-title-desc {
        margin: 0;
        padding: 0 rem(30);
        .item-title {
          color: #333;
          font-size: rem(32);
          font-weight: 700;
        }
        & + .question-item {
          padding: rem(0) rem(30);
          margin: rem(-24) 0 rem(24) 0;
        }
      }
      .item-title {
        color: #333333;
        font-size: rem(30);
        line-height: rem(40);
        font-weight: 400;
        margin-bottom: rem(10);
        &.item-title-filling {
          display: flex;
          line-height: rem(40);
          .item-title-number {
            margin-top: rem(14);
          }
          .question-require {
            margin-top: rem(18);
            margin-right: rem(10);
          }
        }
        .question-require {
          color: red;
        }
      }
      .question-input {
        border-bottom: 1px solid #ccc;
        padding: rem(6) rem(10);
        width: rem(200);
        margin-left: rem(30);
      }
      .item-field {
        width: 80%;
        .question-input {
          width: 100%;
        }
      }
      .item-radio {
        min-height: rem(104);
        line-height: rem(104);
        margin-bottom: rem(20);
        .item-height {
          line-height: 0.8rem;
        }
        ::v-deep {
          .van-radio {
            align-items: flex-start;
          }
          .van-radio__label {
            font-size: rem(30);
            word-break: break-word;
          }
        }
      }
      .item-checkBox {
        min-height: rem(104);
        line-height: rem(104);
        .van-checkbox {
        }
        .item-height {
        }
        ::v-deep {
          .van-checkbox {
            align-items: flex-start;
          }
          .van-checkbox__label {
            font-size: rem(30);
            word-break: break-word;
          }
        }
      }
      .option-item-container {
        margin-bottom: rem(24);
        &:last-child {
          margin-bottom: 0;
        }
      }
      .option-item {
        display: flex;
        align-items: center;
        min-height: rem(60);
      }
      .sub-input-box {
        margin-top: rem(8);
        margin-left: rem(52);
        width: rem(500);
        max-width: calc(100% - #{rem(52)});
        .question-input-line {
          background: transparent;
          padding: rem(8) 0;
          border: none;
          border-bottom: 1px solid #dcdfe6;
          border-radius: 0;
          font-size: rem(28);
          &::after {
            display: none;
          }
          ::v-deep .van-field__control {
            font-size: rem(28);
            color: #333333;
          }
          ::v-deep .van-field__control::placeholder {
            color: #c8c9cc;
          }
        }
      }
      .item-field {
        .uploader-box {
          margin-left:rem(20);
        }
      }
      .uploader-box {
        margin-top: rem(16);
        margin-left: rem(52);
        .img-preview-box {
          position: relative;
          width: rem(140);
          height: rem(140);
          .preview-img {
            width: 100%;
            height: 100%;
            border-radius: rem(12);
            object-fit: cover;
          }
          .delete-icon-box {
            position: absolute;
            top: rem(-10);
            right: rem(-10);
            width: rem(36);
            height: rem(36);
            border-radius: 50%;
            background-color: rgba(0, 0, 0, 0.6);
            display: flex;
            align-items: center;
            justify-content: center;
            z-index: 10;
          }
        }
        .upload-btn-tile {
          width: rem(140);
          height: rem(140);
          background-color: #f7f8fa;
          border: 1px dashed #dcdee0;
          border-radius: rem(12);
          display: flex;
          align-items: center;
          justify-content: center;
          cursor: pointer;
        }
      }
    }
  }
  .submit-btn-container {
    position: fixed;
    bottom: 0;
    left: 0;
    right: 0;
    padding: rem(32);
    background-color: #ffffff;
    z-index: 999;
    .submit-btn {
      height: rem(96);
      border-radius: rem(8);
      text-align: center;
      font-size: rem(32);
      line-height: rem(96);
      background: linear-gradient(90deg, #ff5d5d 0%, #d82626 100%);
      color: #ffffff;
    }
  }
  .submit-btn-container.disabled {
    .submit-btn {
      background: linear-gradient(90deg, #e0e0e0 0%, #cccccc 100%);
    }
  }
}
</style>
